// Complete the Look carousel: arrows and the scroll progress line.
// Behaviour matches trending-products and browse-collections.
//
// This section is re-rendered by product-recommendations.js once the
// recommendations come back, and that swap replaces the track without firing
// shopify:section:load. A MutationObserver on the section root catches it and
// re-binds against the new track.

function initCTL(root) {
  const track = root.querySelector('[data-ctl-track]');
  if (!track) return;
  if (root._ctlTrack === track) return;
  root._ctlTrack = track;

  const prev = root.querySelector('[data-ctl-prev]');
  const next = root.querySelector('[data-ctl-next]');
  const thumb = root.querySelector('[data-ctl-thumb]');
  let ticking = false;

  function step() {
    const item = track.querySelector('.ctl__item');
    if (!item) return track.clientWidth;
    const gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
    return item.getBoundingClientRect().width + gap;
  }

  function update() {
    ticking = false;
    const max = track.scrollWidth - track.clientWidth;

    if (prev) prev.disabled = track.scrollLeft <= 1;
    if (next) next.disabled = track.scrollLeft >= max - 1;

    if (thumb) {
      const ratio = track.scrollWidth > 0 ? track.clientWidth / track.scrollWidth : 1;
      thumb.style.width = Math.min(ratio * 100, 100) + '%';
      thumb.style.insetInlineStart = (track.scrollLeft / track.scrollWidth) * 100 + '%';
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  prev?.addEventListener('click', function () {
    track.scrollBy({ left: -step(), behavior: 'smooth' });
  });
  next?.addEventListener('click', function () {
    track.scrollBy({ left: step(), behavior: 'smooth' });
  });

  track.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();
}

function watch(root) {
  if (root._ctlWatched) return;
  root._ctlWatched = true;
  new MutationObserver(function () {
    initCTL(root);
  }).observe(root, { childList: true, subtree: true });
}

function bootCTL(scope) {
  (scope || document).querySelectorAll('[data-ctl]').forEach(function (root) {
    initCTL(root);
    watch(root);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    bootCTL();
  });
} else {
  bootCTL();
}

document.addEventListener('shopify:section:load', function (e) {
  bootCTL(e.target);
});
